import Service from "../../../Services/index";
import moment from "moment"

const WorkScheduleHistory = {
    namespaced: true,
    state: {
        workScheduleList: [],
        search:{
            shift_id: "",
            date: "",
            employee : '',
        },
        form : {
            id : null,
            date : null,
            department : [],
            new_shift : null,
            old_shift : null,
            employee : null,
            start_work_time : null,
            end_work_time : null,
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_WORK_SCHEDULE_LIST: (state, res) => {
            state.workScheduleList = res.data;
            state.dataPaginate = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                shift_id: "",
                date: "",
                employee : '',
            }
        },
        CLEAR_FORM :(state)=>{
            state. form = {
                id : null,
                date : null,
                new_shift : null,
                old_shift : null,
                department : [],
                employee : null,
                start_work_time : null,
                end_work_time : null,
            }
        },
        SET_FORM_DATA : (state,data)=> {
            state.form = {
                id : data.id,
                date: data.date,
                new_shift: data.new_shift_work,
                old_shift: data.old_shift_work,
                employee: data.employee,
                department: [],
                start_work_time: data.start_work_time,
                end_work_time: data.end_work_time,
            }
        }
    },
    actions: {
        setWorkScheduleHistory({commit}, page = 1) {
            return Service.WorkScheduleHistory.getWorkScheduleHistory(page).then(res => {
                commit("GET_WORK_SCHEDULE_LIST", res);
            })
        },
        show({commit}, id) {
            return Service.WorkScheduleHistory.showWorkScheduleHistory(id).then(response => {
                commit("SET_FORM_DATA", response);
            });
        },
        create({commit}, data) {
            return Service.WorkScheduleHistory.createWorkScheduleHistory(data)
        },
        update({commit}, {id,data}){
            return Service.WorkScheduleHistory.updateWorkScheduleHistory(id,data)
        },
        delete({commit},id) {
            return Service.WorkScheduleHistory.deleteWorkScheduleHistory(id);
        },
        search({commit},data){
            return Service.WorkScheduleHistory.searchWorkScheduleHistory(data).then(res=>{
                commit("GET_WORK_SCHEDULE_LIST", res);
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        clearForm({commit}){
            commit('CLEAR_FORM');
        }
    }
}
export default WorkScheduleHistory;
